module.exports = __webpack_public_path__ + "media/images/iconTrendDown__inFrontOfAccent--dark-e5305f34df08ef479f058b2890c1266d.png";